import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import TermsContainer from 'containers/TermsContainer';

const TermsSettingsPage = () => {
  const title = {
    ko: '이용 약관설정',
    en: 'Terms of Use Settings',
    ja: '利用規約設定',
    zh: '使用条款设置',
  };

  return (
    <PageLayout title="약관설정">
      <TermsContainer type="FACILITY_USAGE_POLICY" title={title} />
    </PageLayout>
  );
};

export default TermsSettingsPage;
